const cases = {
  E1001: {
    case_id: "E1001",
    case_label: "mad heretic Leutard",
    year_start_post_quem: "~1000",
    year_start_ante_quem: "~1000",
    year_end_post_quem: "~1000",
    year_end_ante_quem: "~1000",
    year_approximate: "y",
    dealing_with_them_id: "C1265",
    outcome_id: "C1051, C1052",
  },
  E1002: {
    case_id: "E1002",
    case_label: "learned heretic Vilgard",
    year_start_post_quem: "~1000",
    year_start_ante_quem: "~1000",
    year_end_post_quem: "~1000",
    year_end_ante_quem: "~1000",
    year_approximate: "y",
    dealing_with_them_id: "",
    outcome_id: "C1106, C1147, C1148",
  },
  E1003: {
    case_id: "E1003",
    case_label: "heretics in Sardinia",
    year_start_post_quem: "~1000",
    year_start_ante_quem: "~1000",
    year_end_post_quem: "~1000",
    year_end_ante_quem: "~1000",
    year_approximate: "y",
    dealing_with_them_id: "",
    outcome_id: "C1058",
  },
  E1004: {
    case_id: "E1004",
    case_label: "heretics in Spain",
    year_start_post_quem: "~1000",
    year_start_ante_quem: "~1000",
    year_end_post_quem: "~1000",
    year_end_ante_quem: "~1000",
    year_approximate: "y",
    dealing_with_them_id: "",
    outcome_id: "C1058",
  },
  E1017: {
    case_id: "E1017",
    case_label: "antibaptists in southern France",
    year_start_post_quem: 1013,
    year_start_ante_quem: 1020,
    year_end_post_quem: 1013,
    year_end_ante_quem: 1020,
    year_approximate: "y",
    dealing_with_them_id: "C1367",
    outcome_id: "C1051",
  },
  E1014: {
    case_id: "E1014",
    case_label: "arians in Poitou",
    year_start_post_quem: 1016,
    year_start_ante_quem: 1016,
    year_end_post_quem: 1016,
    year_end_ante_quem: 1016,
    year_approximate: "n",
    dealing_with_them_id: "C1067",
    outcome_id: "C1067",
  },
  E1005: {
    case_id: "E1005",
    case_label: "manicheans in Aquitaine",
    year_start_post_quem: 1018,
    year_start_ante_quem: 1018,
    year_end_post_quem: 1018,
    year_end_ante_quem: 1018,
    year_approximate: "n",
    dealing_with_them_id: "C1067",
    outcome_id: "C1067",
  },
  E1006: {
    case_id: "E1006",
    case_label: "manicheans in Toulouse",
    year_start_post_quem: "~1022",
    year_start_ante_quem: "~1022",
    year_end_post_quem: "~1022",
    year_end_ante_quem: "~1022",
    year_approximate: "y",
    dealing_with_them_id: "C1067",
    outcome_id: "C1058",
  },
  E1007: {
    case_id: "E1007",
    case_label: "learned heresy at Orléans",
    year_start_post_quem: 1022,
    year_start_ante_quem: 1022,
    year_end_post_quem: 1022,
    year_end_ante_quem: 1022,
    year_approximate: "n",
    dealing_with_them_id: "C1067, C1048, C1265",
    outcome_id: "C1097, C1106, C1063, C1228",
  },
  E1009: {
    case_id: "E1009",
    case_label: "evangelical heretics of Arras",
    year_start_post_quem: 1025,
    year_start_ante_quem: 1025,
    year_end_post_quem: 1025,
    year_end_ante_quem: 1025,
    year_approximate: "n",
    dealing_with_them_id: "C1265, C1266, C3241, C1048",
    outcome_id: "C1067, C3237, C1106, C1051, C1323",
  },
  E1013: {
    case_id: "E1013",
    case_label: "ascetic heretics in Périgord",
    year_start_post_quem: 1025,
    year_start_ante_quem: 1050,
    year_end_post_quem: 1025,
    year_end_ante_quem: 1050,
    year_approximate: "y",
    dealing_with_them_id: "C1067",
    outcome_id: "C1067",
  },
  E1008: {
    case_id: "E1008",
    case_label: "ascetic heretics of Monteforte",
    year_start_post_quem: "~1028",
    year_start_ante_quem: "~1028",
    year_end_post_quem: "~1028",
    year_end_ante_quem: "~1028",
    year_approximate: "y",
    dealing_with_them_id: "C1265, C1266, C1990",
    outcome_id: "C1051, C2297, C1063",
  },
  E1015: {
    case_id: "E1015",
    case_label: "manicheans at Charroux",
    year_start_post_quem: 1028,
    year_start_ante_quem: 1028,
    year_end_post_quem: 1028,
    year_end_ante_quem: 1028,
    year_approximate: "n",
    dealing_with_them_id: "C1067",
    outcome_id: "C1067",
  },
  E1016: {
    case_id: "E1016",
    case_label: "heretics in Italy and Greece",
    year_start_post_quem: 1030,
    year_start_ante_quem: 1047,
    year_end_post_quem: 1030,
    year_end_ante_quem: 1047,
    year_approximate: "y",
    dealing_with_them_id: "C1067",
    outcome_id: "C1067",
  },
  E1011: {
    case_id: "E1011",
    case_label: "manicheans at Châlons",
    year_start_post_quem: 1043,
    year_start_ante_quem: 1048,
    year_end_post_quem: 1043,
    year_end_ante_quem: 1048,
    year_approximate: "y",
    dealing_with_them_id: "",
    outcome_id: "C1106",
  },
  E1012: {
    case_id: "E1012",
    case_label: "heretics in Gaul",
    year_start_post_quem: 1049,
    year_start_ante_quem: 1049,
    year_end_post_quem: 1049,
    year_end_ante_quem: 1049,
    year_approximate: "n",
    dealing_with_them_id: "",
    outcome_id: "C1106",
  },
  E1030: {
    case_id: "E1030",
    case_label: "Berengarian heresy",
    year_start_post_quem: 1049,
    year_start_ante_quem: 1049,
    year_end_post_quem: 1080,
    year_end_ante_quem: 1080,
    year_approximate: "n",
    dealing_with_them_id: "",
    outcome_id: "",
  },
  E1010: {
    case_id: "E1010",
    case_label: "heretics of Goslar",
    year_start_post_quem: 1051,
    year_start_ante_quem: 1053,
    year_end_post_quem: 1051,
    year_end_ante_quem: 1053,
    year_approximate: "y",
    dealing_with_them_id: "C1266",
    outcome_id: "C1282, C1106",
  },
  E1018: {
    case_id: "E1018",
    case_label: "anti-eucharistic heretics at Ivois",
    year_start_post_quem: 1112,
    year_start_ante_quem: 1122,
    year_end_post_quem: 1112,
    year_end_ante_quem: 1122,
    year_approximate: "y",
    dealing_with_them_id: "C1266, C1265, C2296",
    outcome_id: "C2272, C1323, C1097, C1106, C1569",
  },
  E1019: {
    case_id: "E1019",
    case_label: "anticlerical heresy of Tanchelm",
    year_start_post_quem: "~1112",
    year_start_ante_quem: "~1112",
    year_end_post_quem: "1124",
    year_end_ante_quem: "1124",
    year_approximate: "y",
    dealing_with_them_id: "C1266, C1638, C1067",
    outcome_id: "1067, C1051, C1737, C1740",
  },
  E1020: {
    case_id: "E1020",
    case_label: "offshoot of Tanchelm's heresy",
    year_start_post_quem: "~1112",
    year_start_ante_quem: "~1112",
    year_end_post_quem: "1114",
    year_end_ante_quem: "1114",
    year_approximate: "y",
    dealing_with_them_id: "C1266",
    outcome_id: "1067",
  },
  E1021: {
    case_id: "E1021",
    case_label: "manicheans near Soissons",
    year_start_post_quem: "~1114",
    year_start_ante_quem: "~1114",
    year_end_post_quem: "~1114",
    year_end_ante_quem: "~1114",
    year_approximate: "y",
    dealing_with_them_id: "C1266, C1265, C1813",
    outcome_id: "C2297, C1063",
  },
  E1023: {
    case_id: "E1023",
    case_label: "wandering preacher Henry the Monk",
    year_start_post_quem: "~1115",
    year_start_ante_quem: "~1115",
    year_end_post_quem: "1148",
    year_end_ante_quem: "1148",
    year_approximate: "y",
    dealing_with_them_id: "C1990, C1265, C1266, C1048, C1638, C1067",
    outcome_id: "C1067, C1051, C1106",
  },
  E1032: {
    case_id: "E1032",
    case_label: "heretics in Aquitaine",
    year_start_post_quem: "1119",
    year_start_ante_quem: "1119",
    year_end_post_quem: "1119",
    year_end_ante_quem: "1119",
    year_approximate: "n",
    dealing_with_them_id: "C1106",
    outcome_id: "C1067",
  },
  E1024: {
    case_id: "E1024",
    case_label: "Petrobrusians",
    year_start_post_quem: "~1119",
    year_start_ante_quem: "~1119",
    year_end_post_quem: "1139",
    year_end_ante_quem: "1139",
    year_approximate: "y",
    dealing_with_them_id: "C1862",
    outcome_id: "C1067, C2297, C1063",
  },
  E1028: {
    case_id: "E1028",
    case_label: "heretics at Liège",
    year_start_post_quem: 1135,
    year_start_ante_quem: 1145,
    year_end_post_quem: 1135,
    year_end_ante_quem: 1145,
    year_approximate: "y",
    dealing_with_them_id: "C1266, C1265",
    outcome_id: "C2297, C1063, C1852, C2298, C2272, C1051",
  },
  E1025: {
    case_id: "E1025",
    case_label: "Arnoldists",
    year_start_post_quem: 1137,
    year_start_ante_quem: 1139,
    year_end_post_quem: 1155,
    year_end_ante_quem: 1155,
    year_approximate: "y",
    dealing_with_them_id: "C1106, C1097, C1862, C1048, C1266",
    outcome_id: "C1569, C1063",
  },
  E1026: {
    case_id: "E1026",
    case_label: "ascetic heretics at Cologne",
    year_start_post_quem: 1143,
    year_start_ante_quem: 1144,
    year_end_post_quem: 1143,
    year_end_ante_quem: 1144,
    year_approximate: "y",
    dealing_with_them_id: "C1266, C1813",
    outcome_id: "C2297, C1063",
  },
  E1027: {
    case_id: "E1027",
    case_label: "donatist heretics at Cologne",
    year_start_post_quem: 1143,
    year_start_ante_quem: 1144,
    year_end_post_quem: 1143,
    year_end_ante_quem: 1144,
    year_approximate: "y",
    dealing_with_them_id: "C1067",
    outcome_id: "C1067",
  },
  E1022: {
    case_id: "E1022",
    case_label: "eccentric heretic Eudo of Stella",
    year_start_post_quem: "~1145",
    year_start_ante_quem: "~1145",
    year_end_post_quem: "1148",
    year_end_ante_quem: "1148",
    year_approximate: "y",
    dealing_with_them_id: "C1266, C1048, C1067, C1852",
    outcome_id: "C1852, C1862, C1106, C1323, C1067, C1740, C1106",
  },
  E1033: {
    case_id: "E1033",
    case_label: "weavers at Toulouse",
    year_start_post_quem: "1145",
    year_start_ante_quem: "1145",
    year_end_post_quem: "1145",
    year_end_ante_quem: "1145",
    year_approximate: "y",
    dealing_with_them_id: "C1067",
    outcome_id: "C2272",
  },
  E1031: {
    case_id: "E1031",
    case_label: "manicheans at Agen",
    year_start_post_quem: "~1150",
    year_start_ante_quem: "~1150",
    year_end_post_quem: "~1150",
    year_end_ante_quem: "~1150",
    year_approximate: "y",
    dealing_with_them_id: "C1067",
    outcome_id: "C1067",
  },
};

export default cases;
